<template>
  <div class="home">
    <div class="head-title">公告</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <nav>
            <el-button @click="onAdd" type="primary" icon="el-icon-plus"
              >添加</el-button
            >
            <!-- 地区 -->
            <el-select
              style="
                margin-left: 24px;
                width: 24.0rem;
                display: inline-flex;
                min-width: auto;
              "
              clearable
              v-model="valueesedd"
              placeholder="请选择发布范围"
              @change="haha"
            >
              <el-option
                v-for="item in optionss"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              style="
                margin-left: 24px;
                width: 24.0rem;
                display: inline-flex;
                min-width: auto;
              "
              clearable
              v-model="valueeseddss"
              placeholder="请选择公告类别"
              @change="haha"
            >
              <el-option
                v-for="item in optionssse"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </nav>

          <el-table
            :data="tableData.data"
            
            border
            style="width: 100%; margin-top: 2.0rem"
          >
            <el-table-column
              prop="title"
              label="标题"
              show-overflow-tooltip
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="addtime"
              label="发布时间"
              style="width: 40%"
            ></el-table-column>
            <el-table-column
              prop="scope_name"
              label="发布范围"
              style="width: 40%"
            >
            </el-table-column>

            <el-table-column
              prop="notice_category_name"
              label="发布类型"
              style="width: 20%"
            ></el-table-column>
            <el-table-column prop="state" label="发布状态" style="width: 40%">
              <template slot-scope="scope">
                <div v-if="scope.row.state == 1">{{ fabule.a }}</div>
                <div v-else-if="scope.row.state == 2" class="aaas">
                  {{ fabule.b }}
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" style="width: 10%">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  @click="dele(scope.row.id)"
                  size="mini"
                >
                  删除
                </el-button>
                <el-button
                  type="primary"
                  @click="
                    (dialogVisible = true),
                      modify(
                        scope.row.id,
                        scope.row.title,
                        scope.row.content,
                        scope.row.scope,
                        scope.row
                      )
                  "
                  size="small"
                >
                  编辑
                </el-button>
                <!-- <el-button
                  type="text"
                  @click="fabu(scope.row.id)"
                  size="small"
                  style="color: rgb(40, 144, 221)"
                >
                  <img
                    src="../../../assets/783b17cd721e05d1c08c7bd4c9e6327.png"
                    alt
                    style="position: relative; top: 1.0rem; right: 4px"
                  />发布
                </el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="tableData.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="haha"
            />
          </div>
        </div>
        <el-dialog
        center
          title="修改公告"
          :visible.sync="dialogVisible"
          top="5vh"
          width="80%"
          lock-scroll
          append-to-body
        >
          <el-form ref="form" :model="form" label-width="10.0rem">
            <el-form-item label="文章标题：">
              <el-input clearable v-model="form.title">{{
                form.title
              }}</el-input>
            </el-form-item>
            <el-form-item label="文章封面：">
              <el-upload
                class="upload-demo"
                :action="
                  `${baseURL}/api/Alioss/uploadTotal?totaltoken=` +
                  this.tooken.totaltoken +
                  '&account_id=' +
                  this.tooken.account_id
                "
                :on-remove="handleRemoveCover"
                :before-remove="beforeRemoveCover"
                :limit="1"
                accept="image/png, image/jpg"
                :on-success="chenggongCover"
                :file-list="fileListCover"
                list-type="picture"
              >
                <el-button type="primary" @click="bianji">上传图片</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb，图片尺寸请保证在350*120像素
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="发布范围：">
              <el-select
                clearable
                v-model="valueee"
                disabled
                placeholder="请选择"
              >
                <el-option
                  v-for="item in optionss"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发布类型：">
              <el-select
                clearable
                v-model="valueese"
                disabled
                placeholder="请选择"
              >
                <el-option
                  v-for="item in optionssse"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="附件上传"
              prop="none"
              style="margin-top: 2.0rem"
              v-if="valueese == 1"
            >
              <el-upload
                class="upload-demo"
                :action="
                  `${baseURL}/api/Alioss/uploadTotal?totaltoken=` +
                  this.tooken.totaltoken +
                  '&account_id=' +
                  this.tooken.account_id
                "
                :on-preview="handlePreview"
                :on-success="chenggong"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传xls文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="文章内容：" v-if="valueese != 1">
              <div style="overflow: hidden">
                <vue-ueditor-wrap
                  v-model="mani"
                  :config="myConfig"
                ></vue-ueditor-wrap>
              </div>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="vak()">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
        center
          title="添加公告"
          :visible.sync="onSubmit"
          top="5vh"
          width="80%"
          lock-scroll
          append-to-body
        >
          <el-form ref="form" :model="form" label-width="10.0rem">
            <el-form-item label="文章标题：">
              <el-input clearable v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="文章封面：">
              <el-upload
                class="upload-demo"
                :action="
                  `${baseURL}/api/Alioss/uploadTotal?totaltoken=` +
                  this.tooken.totaltoken +
                  '&account_id=' +
                  this.tooken.account_id
                "
                :on-remove="handleRemoveCover"
                :before-remove="beforeRemoveCover"
                :limit="1"
                accept="image/png, image/jpg"
                :on-success="chenggongCover"
                :file-list="fileListCover"
                list-type="picture"
              >
                <el-button type="primary">上传图片</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb，图片尺寸请保证在350*120像素
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="发布范围：">
              <el-select clearable v-model="valuee" placeholder="请选择">
                <el-option
                  v-for="item in optionss"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公告类别：">
              <el-select clearable v-model="valuees" placeholder="请选择">
                <el-option
                  v-for="item in optionssd"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="附件上传"
              prop="none"
              style="margin-top: 2.0rem"
              v-if="valuees == 1"
            >
              <el-upload
                class="upload-demo"
                :action="
                  `${baseURL}/api/Alioss/uploadTotal?totaltoken=` +
                  this.tooken.totaltoken +
                  '&account_id=' +
                  this.tooken.account_id
                "
                :on-preview="handlePreview"
                :on-success="chenggong"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传xls文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="文章内容：" v-if="valuees != 1">
              <div style="overflow: hidden">
                <vue-ueditor-wrap
                  v-model="value"
                  :config="myConfig"
                ></vue-ueditor-wrap>
              </div>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button @click="onSubmit = false">取 消</el-button>
            <el-button type="primary" @click="numoo()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  data() {
    return {
      tableData: {
        total: 0,
        data: [],
      },
      formInline: {
        user: "",
      },
      dialogVisible: false,
      form: {
        name: "",
        title: "",
        cover: "",
      },
      newList: {
        a: "一级代理商查看",
        b: "二级代理商查看",
        c: "所有的代理商查看",
      },
      fabule: {
        a: "未发布",
        b: "已发布",
      },
      onSubmit: false,
      modifys: "", //修改点击来接收的id,
      dengj: "",
      fabufanw: "",
      mani: "", //价格
      tooken: "",
      title: {},

      value: "填写文章",
      myConfig: {
        // 编辑器不自动被内容撑高
        // autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: "https://api.weijub.com/upload/controller.php",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/UEditor/",
        zIndex: 2003,
      },
      baseURL: this.axios.defaults.baseURL,
      fileList: [],
      fileListCover: [],
      options: [
        {
          value: "0",
          label: "一级代理商查看",
        },
        {
          value: "1",
          label: "二级代理商查看",
        },
        {
          value: "2",
          label: "所有的代理商查看",
        },
        {
          value: "3",
          label: "企业CRM查看",
        },
      ],
      optionss: [
        {
          value: 0,
          label: "一级代理商查看",
        },
        {
          value: 1,
          label: "二级代理商查看",
        },
        {
          value: 2,
          label: "所有的代理商查看",
        },
        {
          value: 3,
          label: "企业CRM查看",
        },
      ],
      optionssd: [],
      optionssse: [],
      valueee: "",
      valuee: "",
      valuees: "",
      valueese: "",
      valueesedd: "",
      valueeseddss: "",
      url: "",
      cover: "",
      baseURL: this.axios.defaults.baseURL,
      listQuery: {
        page: 1,
        limit: 20
      },
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
    }
    this.haha();
  },
  components: {
    VueUeditorWrap,
  },
  methods: {
    onAdd() {
      this.fileList = [];
      this.fileListCover = [];
      this.onSubmit = true;
    },
    bianji() {
      this.fileList = [];
      this.fileListCover = [];
    },
    handlePreviewCover(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemoveCover(file, fileList) {},
    beforeRemoveCover(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, {
        type: "warning",
      });
    },
    chenggongCover(response, file, fileList) {
      var arr = [];
      fileList.map((i) => {
        arr.push(i.response.data);
      });
      this.cover = arr[0].url.toString();
    },
    chenggong(response, file, fileList) {
      var arr = [];
      fileList.map((i) => {
        arr.push(i.response.data);
      });
      this.url = arr[0].url.toString();
    },
    handlePreview(file) {},
    handleRemove(file, fileList) {},
    handleExceed() {
      this.$message.warning(
        `当前限制选择 1 个文件，如需更换请先删除`
      );
    },
    handleCurrentChange(val) {
      this.axios
        .post(
          "/api/notice/getNoticeList",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            page: val,

          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    fabu(a) {
      this.axios
        .post(
          "/api/notice/pushNotice",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            id: a,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
          this.haha();
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    // tooken验证
    haha() {
      this.axios
        .post(
          "/api/notice/getNoticeList",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            scope: this.valueesedd,
            notice_category_id: this.valueeseddss,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
      this.axios
        .post(
          "/api/NoticeCategory/getNoticeCategoryList",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.optionssd = res.data.data.data;
          this.optionssse = res.data.data.data;
        })
        .catch(function (err) {});
    },
    //  通过点击事件触发监听事件rowbundleRenderer
    modify(e, l, el, ol, row) {
      this.valueese = row.notice_category_id;
      this.valueee = row.scope;
      this.fabufanw = ol;
      // this.valueee = ol;
      this.modifys = e;
      this.mani = el;
      this.form.title = l;
      // this.valueese = row;
      if (row.cover) {
        this.cover = row.cover;
        this.fileListCover = [
          {
            url: row.cover,
          },
        ];
      } else {
        this.cover = "";
        this.fileListCover = [];
      }

      this.fileList = [
        {
          url: row.knowledge_image,
        },
      ];
    },
    vak() {
      console.log(this.valueese);
      // 修改代理商等级
      this.axios
        .post(
          "/api/notice/editNotice",
          qs.stringify({
            content: this.mani,
            id: this.modifys,
            title: this.form.title,
            totaltoken: this.tooken.totaltoken,
            scope: this.valueee,
            notice_category_id: this.valueese.notice_category_id,
            cover: this.cover,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          if (res.data.code == 1) {
            this.dialogVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.dialogVisible = true;
            this.$message.error(res.data.msg);
          }
          this.haha();
        })
        .catch(function (err) {});
    },

    handleClick(row) {},
    // 删除代理等级管理
    dele(e) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/api/notice/delNotice",
              qs.stringify({
                id: e,
                totaltoken: this.tooken.totaltoken,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/Tagent");
              }
              this.haha();
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message.error("取消删除");
        });
    },
    numoo() {
      this.axios
        .post(
          "/api/notice/addNotice",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            title: this.form.name,
            content: this.value,
            scope: this.valuee,
            notice_category_id: this.valuees,
            knowledge_image: this.url,
            cover: this.cover,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }

          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.haha();
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-upload-list--picture .el-upload-list__item-thumbnail {
  width: 155px;
  height: 65px;
}
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0,0,0,0.1);
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 23px 31px;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 26px;
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
.ovued {
  margin: 0 auto;
  width: 7.0rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.aaas {
  color: blue;
}
</style>

